//# sourceMappingURL=function.mjs.map
/// <reference types="./function.d.mts" />
/**
 * Takes a single argument and always returns its input value.
 */
export function identity(x) {
  return x;
}
